import clsx from "clsx";
import React, { useContext } from "react";
import styled from "@emotion/styled";
import { ResizeContext } from "./ResizeContextProvider";
import { Overlay } from "office-ui-fabric-react";
import { css } from "@emotion/css";

export const ResizeLine = () => {
  const [resizeState] = useContext(ResizeContext);

  if (!resizeState.isResizing) return null;

  const left1 = resizeState.startMouseX;
  const left2 = resizeState.mouseX;

  return (
    <Overlay
      className={css`
        background-color: transparent;
      `}
    >
      <Root>
        <Line style={{ left: left1 }} />
        <Line
          style={{ left: left2 }}
          className={clsx({ cantResize: !resizeState.canResize })}
        />
      </Root>
    </Overlay>
  );
};

const Root = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  pointer-events: none;
`;

export const Line = styled.div`
  width: 2px;
  height: 100%;
  background-color: #005aa1;
  position: absolute;
  cursor: col-resize;
  &.cantResize {
    background: red;
  }
`;
